var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 90,
    viewBox: "0 0 94 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 52.5C94 77.3528 69.8528 90 45 90C20.1472 90 0.5 65.8528 0.5 41C0.5 16.1472 20.1472 0 45 0C69.8528 0 94 27.6472 94 52.5Z",
    fill: "#e52e6eff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.57 2.08) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 28C54 28 55.2 28 58.8 28.2C65.3 28.5 69.4 32.6 69.7 39.1C69.9 42.7 69.9 43.9 69.9 53.4C69.9 62.9 69.9 64.1 69.7 67.7C69.4 74.2 65.3 78.3 58.8 78.6C55.2 78.8 54 78.8 44.5 78.8C35 78.8 33.8 78.8 30.2 78.6C23.7 78.3 19.6 74.2 19.3 67.7C19.1 64.1 19.1 62.9 19.1 53.4C19.1 43.9 19.1 42.7 19.3 39.1C19.6 32.6 23.7 28.5 30.2 28.2C33.8 28 35 28 44.5 28ZM44.5 32.6C35.2 32.6 34 32.6 30.4 32.8C25.6 33 24 34.6 23.8 39.4C23.6 43 23.6 44.2 23.6 53.5C23.6 62.8 23.6 64 23.8 67.6C24 72.4 25.6 74 30.4 74.2C34 74.4 35.2 74.4 44.5 74.4C53.8 74.4 55 74.4 58.6 74.2C63.4 74 65 72.4 65.2 67.6C65.4 64 65.4 62.8 65.4 53.5C65.4 44.2 65.4 43 65.2 39.4C65 34.6 63.4 33 58.6 32.8C55.1 32.6 53.8 32.6 44.5 32.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 40.5C37.3 40.5 31.6 46.3 31.6 53.4C31.6 60.5 37.3 66.3 44.5 66.3C51.6 66.3 57.3 60.5 57.3 53.4C57.3 46.3 51.6 40.5 44.5 40.5ZM44.5 61.8C39.8 61.8 36.1 58 36.1 53.4C36.1 48.8 39.8 45 44.5 45C49.1 45 52.8 48.8 52.8 53.4C52.8 58 49.1 61.8 44.5 61.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.7,
    cy: 38.7,
    r: 3.1,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4f68b7d39e7ec3d05d142aba28cd261b.svg";
export { ForwardRef as ReactComponent };